import React, { useEffect, useState } from "react";
import $ from "jquery";
import { Form } from "react-bootstrap";
import { toast } from 'react-toastify';

import {
    addTvApkFaq,
    updateTvApkFaq,
    deleteTvApkFaq
} from "../../../../../Services/TvApksService/TvApkService";

import { getEnvUrl, getToken } from "../../../../../utils/Api";

const TvApkFaqs = ({ tvApkId }) => {

    const [faqs, setFaqs] = useState([]);

    const [loading, setLoading] = useState(false);

    const [showForm, setShowForm] = useState(false);

    const [editId, setEditId] = useState(null);

    const [formData, setFormData] = useState({
        question: "",
        answer: "",
        sort_order: 0
    });
    const [errors, setErrors] = useState({
        question: "",
        answer: ""
    });
    useEffect(() => {

        if (tvApkId) {
            fetchFaqs();
        }

    }, [tvApkId]);

    const fetchFaqs = async () => {

        try {

            setLoading(true);

            $.ajax({

                url: `${getEnvUrl()}/admin/tvapk/getFaqs`,
                type: "GET",

                headers: {
                    Authorization: `Bearer ${getToken()}`
                },

                data: {
                    tv_apk_id: tvApkId
                },

                success: function (response) {

                    if (response.status) {

                        setFaqs(response.data || []);

                    } else {

                        setFaqs([]);

                    }

                },

                error: function (error) {

                    console.error("FAQ Fetch Error:", error);

                },

                complete: function () {

                    setLoading(false);

                }

            });

        } catch (error) {

            console.error(error);

            setLoading(false);

        }

    };

    const handleChange = (e) => {

        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: value.trim() ? "" : `${name === "question" ? "Question" : "Answer"} is required`
        }));

    };

    const resetForm = () => {

        setFormData({
            question: "",
            answer: "",
            sort_order: 0
        });

        setErrors({
            question: "",
            answer: ""
        });

        setEditId(null);

        setShowForm(false);

    };

    const handleSubmit = async () => {

        try {
            const newErrors = {
                question: "",
                answer: ""
            };

            if (!formData.question.trim()) {
                newErrors.question = "Question is required";
            }

            if (!formData.answer.trim()) {
                newErrors.answer = "Answer is required";
            }

            setErrors(newErrors);

            if (Object.values(newErrors).some(Boolean)) {
                return;
            }
            setLoading(true);

            if (editId) {
                const response = await updateTvApkFaq({
                    faq_id: editId,
                    ...formData
                });

                if (!response.status) {
                    toast.error(response.errorMessage);
                    setLoading(false);

                    return;
                }

                toast.success("FAQ Updated successfully");
            } else {
                const response = await addTvApkFaq({
                    tv_apk_id: tvApkId,
                    ...formData
                });

                if (!response.status) {
                    toast.error(response.errorMessage);
                    setLoading(false);

                    return;
                }

                toast.success("FAQ Added successfully");
            }

            resetForm();
            fetchFaqs();

        } catch (error) {

            console.error("Save FAQ Error:", error);

            alert("Failed to save FAQ");

            setLoading(false);

        }

    };

    const handleEdit = (faq) => {

        setEditId(faq.id);

        setFormData({
            tv_apk_id: tvApkId,
            question: faq.question || "",
            answer: faq.answer || "",
            sort_order: faq.sort_order || 0
        });

        setShowForm(true);

    };

    const handleDelete = async (faqId) => {


        try {

            await deleteTvApkFaq({
                faq_id: faqId,
                tv_apk_id: tvApkId
            });

            toast.success("FAQ Deleted successfully")

            fetchFaqs();

        } catch (error) {

            console.error("Delete FAQ Error:", error);

            alert("Failed to delete FAQ");

        }

    };

    return (
        <>
            <div className="card shadow-sm border-0">

                <div className="card-body">

                    <div className="d-flex justify-content-between align-items-center mb-4">

                        <div>
                            <h4 className="mb-0">
                                FAQs
                            </h4>

                            <small className="text-muted">
                                Manage frequently asked questions
                            </small>
                        </div>

                        <button
                            className="btn btn-primary"
                            onClick={() => {
                                resetForm();
                                setShowForm(true);
                            }}
                        >
                            <i className="bi bi-plus-circle me-2"></i>
                            Add FAQ
                        </button>

                    </div>

                    {
                        loading ? (

                            <div className="text-center py-5">

                                <div
                                    className="spinner-border text-primary"
                                    role="status"
                                >
                                    <span className="visually-hidden">
                                        Loading...
                                    </span>
                                </div>

                                <div className="mt-2">
                                    Loading FAQs...
                                </div>

                            </div>

                        ) : faqs.length > 0 ? (

                            <div
                                className="accordion"
                                id="faqAccordion"
                            >

                                {
                                    faqs.map((faq, index) => (

                                        <div
                                            className="accordion-item border mb-2 rounded overflow-hidden"
                                            key={faq.id}
                                        >

                                            <h2
                                                className="accordion-header"
                                                id={`heading-${faq.id}`}
                                            >

                                                <button
                                                    className="accordion-button collapsed"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#collapse-${faq.id}`}
                                                    aria-expanded="false"
                                                    aria-controls={`collapse-${faq.id}`}
                                                >

                                                    <div className="d-flex align-items-center w-100">

                                                        <span className="badge bg-primary me-3">
                                                            #{index + 1}
                                                        </span>

                                                        <span className="fw-semibold">
                                                            {faq.question}
                                                        </span>

                                                    </div>

                                                </button>

                                            </h2>

                                            <div
                                                id={`collapse-${faq.id}`}
                                                className="accordion-collapse collapse"
                                                aria-labelledby={`heading-${faq.id}`}
                                                data-bs-parent="#faqAccordion"
                                            >

                                                <div className="accordion-body">

                                                    <div className="mb-3 text-muted">
                                                        {faq.answer}
                                                    </div>

                                                    <div className="d-flex gap-2">

                                                        <button
                                                            className="btn btn-sm btn-outline-primary"
                                                            onClick={() => handleEdit(faq)}
                                                        >
                                                            <i className="bi bi-pencil-square me-1"></i>
                                                            Edit
                                                        </button>

                                                        <button
                                                            className="btn btn-sm btn-outline-danger"
                                                            onClick={() => handleDelete(faq.id)}
                                                        >
                                                            <i className="bi bi-trash me-1"></i>
                                                            Delete
                                                        </button>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                    ))
                                }

                            </div>

                        ) : (

                            <div className="text-center py-5 text-muted">

                                <i
                                    className="bi bi-question-circle"
                                    style={{
                                        fontSize: "3rem"
                                    }}
                                />

                                <div className="mt-2">
                                    No FAQs Found
                                </div>

                            </div>

                        )
                    }

                </div>

            </div>

            {
                showForm && (

                    <>
                        <div
                            className="modal fade show"
                            style={{
                                display: "block",
                                backgroundColor: "rgba(0,0,0,0.5)"
                            }}
                        >

                            <div className="modal-dialog modal-lg modal-dialog-centered">

                                <div className="modal-content">

                                    <div className="modal-header">

                                        <h5 className="modal-title">
                                            {
                                                editId
                                                    ? "Edit FAQ"
                                                    : "Create FAQ"
                                            }
                                        </h5>

                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={resetForm}
                                        />

                                    </div>

                                    <div className="modal-body">

                                        <div className="mb-3">

                                            <label className="form-label fw-semibold">
                                                Question
                                            </label>
                                            <Form.Control
                                                type="text"
                                                name="question"
                                                value={formData.question}
                                                onChange={handleChange}
                                                placeholder="Enter FAQ question"
                                                isInvalid={!!errors.question}
                                            />

                                            <Form.Control.Feedback
                                                type="invalid"
                                                style={{
                                                    display: errors.question ? "block" : "none"
                                                }}
                                            >
                                                {errors.question}
                                            </Form.Control.Feedback>

                                        </div>

                                        <div className="mb-3">

                                            <label className="form-label fw-semibold">
                                                Answer
                                            </label>

                                            <Form.Control
                                                as="textarea"
                                                rows={6}
                                                name="answer"
                                                value={formData.answer}
                                                onChange={handleChange}
                                                placeholder="Enter FAQ answer"
                                                isInvalid={!!errors.answer}
                                            />

                                            <Form.Control.Feedback
                                                type="invalid"
                                                style={{
                                                    display: errors.answer ? "block" : "none"
                                                }}
                                            >
                                                {errors.answer}
                                            </Form.Control.Feedback>

                                        </div>

                                    </div>

                                    <div className="modal-footer">

                                        <button
                                            className="btn btn-light"
                                            onClick={resetForm}
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            className="btn btn-primary"
                                            onClick={handleSubmit}
                                            disabled={loading}
                                        >
                                            {
                                                loading ? (
                                                    <>
                                                        <span
                                                            className="spinner-border spinner-border-sm me-2"
                                                            role="status"
                                                        />
                                                        Saving...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="bi bi-check-circle me-2"></i>
                                                        {
                                                            editId
                                                                ? "Update FAQ"
                                                                : "Save FAQ"
                                                        }
                                                    </>
                                                )
                                            }
                                        </button>

                                    </div>

                                </div>

                            </div>

                        </div>

                        <div className="modal-backdrop fade show"></div>
                    </>

                )
            }
        </>
    );

};

export default TvApkFaqs;